import { Component } from '@angular/core';

@Component({
  selector: 'shelter-list-tools',
  template: require('./shelter-list-tools.component.html'),
  styles: [require('./shelter-list-tools.component.scss')],
})
export class ShelterListToolsComponent {}
